import Repository from "../../repository";

export default {
    Get: (payload) => Repository.post(`/api/Guests/MaintenanceReportPublic/Get`, payload),
    GetById: (payload) => Repository.post(`/api/Guests/MaintenanceReportPublic/GetById`, payload),
    Add: (payload) => Repository.post(`/api/Guests/MaintenanceReportPublic/Add`, payload),
    Add: (payload) => Repository.post(`/api/Guests/MaintenanceReportPublic/Add`, payload),
}
